<template>
  <div class="photo-thumb">
    <div class="video-thumb__content" v-if="vlog">
      <div class="d-flex avatarBox mt-2">
        <AvatarComponent
          size="38"
          :url="vlog.profile && vlog.profile.picture"
        />
        <HeaderThumb :vlog="vlog"/>
      </div>
    </div>
    <div @click="checkToLinkDetailPost(vlog)">
      <v-img
        v-if="srcThumb"
        :src="srcThumb"
        class="pointer mt-3"
        :height="height"
        aspect-ratio="2"
        @click="openPhotoPage()"
      >
      </v-img>
    </div>
  </div>
</template>

<script>
import ButtonLike from "@/components/Buttons/ButtonLike";
import HeaderThumb from "@/components/Thumbnails/HeaderThumb";
export default {
  props: {
    srcThumb: String,
    indexThumb: Number,
    vlog: Object,
    photo: Object,
    height: String,
    isLinkToDetailPost: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ButtonLike,
    HeaderThumb
  },
  data() {
    return {};
  },
  methods: {
    openPhotoPage() {
      this.$emit("openDialogDetail", this.vlog || null);
    },
    checkToLinkDetailPost(vlog) {
      if(vlog && vlog.id && this.isLinkToDetailPost) {
        this.$emit('linkToDetailPost', vlog.id)
      } else return true;
    }
  },
};
</script>